import { ILoginData } from '../types';
import { request } from './config';

export const login = (data: ILoginData) => request.post('/login', data);

export const refreshToken = () => request.get('/refresh_token');

export const logout = () => request.post('/logout');
